const state = {

};

const getters = {

};

const actions = {
    async get({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/activity-logs`, { params: params })
                .then(response => {
                    response.data.data.pages = params
                    resolve(response)
                })
                .catch(error => reject(error));
        });
    },
    async create({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`/api/activity-logs`, params)
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => reject(error));
        });
    },
    async getActivityLogCase({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/activity-logs/case-log`, { params: params })
                .then(response => {
                    response.data.data.pages = params
                    resolve(response)
                })
                .catch(error => reject(error));
        });
    },
    async createLogCase({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            for( var i = 0; i < params.attachments.length; i++ ){
                let photo = params.attachments[i];
                formData.append('photos[' + i + ']', photo);
                formData.append('fileTitles[' + i + ']', photo.image_file_title || '');
            }
            formData.append("work_item_id", params.work_item_id);
            formData.append("work_item_type", params.work_item_type);
            formData.append("time_stamp", params.time_stamp);
            formData.append("action", params.action || '' );
            formData.append("actor_id", params.actor_id || '' );
            formData.append("actor", params.actor || '' );
            formData.append("remark", params.remark || '');
            formData.append("log_type", params.log_type);
            formData.append("nlt_case_key_action", params.nlt_case_key_action || '');
            formData.append("is_allow_change_status", params.is_allow_change_status || false);
            global.axios.post("/api/activity-logs",formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                resolve(response.data.data)
            })
            .catch(error => reject( error ));
        });
    },
    async createLogCaseWithOutDated({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            for( var i = 0; i < params.attachments.length; i++ ){
                let photo = params.attachments[i];
                formData.append('photos[' + i + ']', photo);
                formData.append('file_titles[' + i + ']', photo.image_file_title || '');
            }
            for( var j = 0; j < params.attachmentsDelete.length; j++ ){
                let photoD = params.attachmentsDelete[j];
                formData.append('photosDelete[' + j + ']', photoD.id);
            }
            formData.append("work_item_id", params.work_item_id);
            formData.append("work_item_type", params.work_item_type);
            formData.append("time_stamp", params.time_stamp);
            formData.append("action", params.action || '' );
            formData.append("actor_id", params.actor_id || '' );
            formData.append("actor", params.actor || '' );
            formData.append("remark", params.remark || '');
            formData.append("log_type", params.log_type);
            formData.append("nlt_case_key_action", params.nlt_case_key_action || '');
            formData.append("is_allow_change_status", params.is_allow_change_status || false);

            global.axios.post(`/api/activity-logs/case-log/${params.id}`, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                resolve(response.data.data)
            })
            .catch(error => reject( error ));
        });
    },
    async update({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.put(`/api/activity-logs/${params.id}`, params)
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => reject(error));
        });
    },
    async updateByEmail({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.put(`/api/activity-logs/update-by-email/${params.email_id}`)
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => reject(error));
        });
    },
    async delete({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`/api/activity-logs`, {
                    data: {
                        ids: ids
                    }
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => reject(error));
        });
    },
    async deleteCaseLog({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`/api/activity-logs`, {
                    data: {
                        ids: ids,
                        allow_update_status:true
                    }
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => reject(error));
        });
    },
    async changeStatus({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`/api/activity-logs/status`, { params: params })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => reject(error));
        });
    },
    async exportActivityNLT({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/activity-logs/export-nlt`, {
                    params: params,
                    responseType: 'blob'
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    // 
    async createLogWithAttachment({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            if(params.photos && params.photos.length) {
                for( var i = 0; i < params.photos.length; i++ ){
                    let photo = params.photos[i];
                    formData.append('photos[' + i + ']', photo);
                    formData.append('file_titles[' + i + ']', photo.image_file_title || '');
                }
            }

            for (const [key, value] of Object.entries(params)) {
                if(!['photos'].includes(key)) {
                    formData.append(key, value ? value : '');
                }
            }
            global.axios.post("/api/activity-logs",formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                resolve(response.data.data)
            })
            .catch(error => reject( error ));
        });
    },
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
}